import './public-path.js'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './http/config'
import './permissions'
import './permissions/version'
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import EngineTag from '@/components/EngineTag/EngineTag.vue'
import {
  Image,
  Space,
  Badge,
  Icon,
  Breadcrumb,
  Affix,
  Button,
  Row,
  Col,
  Tabs,
  Pagination,
  Input,
  Rate,
  Popover,
  Dropdown,
  Menu,
  Carousel,
  Empty,
  Upload,
  Spin,
  Progress,
  Modal,
  Tooltip,
  Radio,
  Select,
  TreeSelect,
  Form,
  DatePicker,
  ConfigProvider,
  Table,
  Switch,
  Checkbox,
} from 'ant-design-vue'
import 'animate.css'
import tools from '@/utils/utils'
import ElementPlus from 'element-plus'
import { setThemeColor } from '@/utils/theme'

if (!window.__POWERED_BY_QIANKUN__) {
  import('element-plus/lib/theme-chalk/index.css')
} else {
  setThemeColor('microApp')
}

import(
  `./styles/theme/${!window.__POWERED_BY_QIANKUN__ ? 'default' : 'qiankun'}.theme.less`
)

const urlParams = new URLSearchParams(window.location.search)
const enterpriseId = urlParams.get('enterpriseId')
sessionStorage.setItem('enterpriseId', enterpriseId || '')

let instance = null

async function render(props = {}) {
  const { container, routerBase } = props
  console.log('props', props)

  instance = createApp(App)
  instance.config.globalProperties.$tools = tools
  instance.config.globalProperties.$KeepDecimalFull = (num, many = 1) => {
    let result = parseFloat(num)
    if (isNaN(result)) {
      alert('传递参数错误，请检查！')
      return false
    }
    result = Math.round(num * 100) / 100
    let s_x = result.toString() //将数字转换为字符串

    let pos_decimal = s_x.indexOf('.') //小数点的索引值

    // 当整数时，pos_decimal=-1 自动补0
    if (pos_decimal < 0) {
      pos_decimal = s_x.length
      s_x += '.'
    }

    // 当数字的长度< 小数点索引+2时，补0
    while (s_x.length <= pos_decimal + many) {
      s_x += '0'
    }
    return s_x
  }
  instance.component('EngineTag', EngineTag)
  //保留小数不足补0
  instance.use(ElementPlus)
  instance.use(store)
  instance.use(router)

  instance.use(PerfectScrollbar)
  instance.use(Icon)
  instance.use(Breadcrumb)
  instance.use(Affix)
  instance.use(Button)
  instance.use(Row)
  instance.use(Col)
  instance.use(Tabs)
  instance.use(Pagination)
  instance.use(Input)
  instance.use(Rate)
  instance.use(Popover)
  instance.use(Dropdown)
  instance.use(Menu)
  instance.use(Carousel)
  instance.use(Empty)
  instance.use(Upload)
  instance.use(Spin)
  instance.use(Progress)
  instance.use(Modal)
  instance.use(Tooltip)
  instance.use(Radio)
  instance.use(Select)
  instance.use(TreeSelect)
  instance.use(Form)
  instance.use(DatePicker)
  instance.use(ConfigProvider)
  instance.use(Table)
  instance.use(Switch)
  instance.use(Checkbox)
  instance.use(Space)
  instance.use(Badge)
  instance.use(Image)
  instance.mount(container ? container.querySelector('#app') : '#app')
}

if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

export async function bootstrap() {
  console.log('[vue] vue app bootstraped')
}

export async function mount(props) {
  // 标记当前启动形式为微服务启动
  // store.commit("app/microChange", true);
  await render(props)
}

export async function unmount() {
  instance.unmount()
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  let sessionEnterpriseId = sessionStorage.getItem('enterpriseId')

  //如果去的目标企业存在，并且不等于session的Id
  if (to.query.enterpriseId && to.query.enterpriseId != sessionEnterpriseId) {
    sessionStorage.setItem('enterpriseId', to.query.enterpriseId)
  }

  //如果更换的路由页面没有带企业Id 但是来的时候企业Id带着，则赋值企业Id
  if (!to.query.enterpriseId && from.query.enterpriseId) {
    to.query.enterpriseId = from.query.enterpriseId
    sessionStorage.setItem('enterpriseId', to.query.enterpriseId)
    next({
      path: to.path,
      query: to.query,
    })
  } else {
    next()
  }
})
